<template>
  <div class="brand-carousel-section">
    <div class="brand-carousel-label">{{ t('brands.carouselLabel') }}</div>
    <div class="brand-track-wrap">
      <div class="brand-track">
        <div
          v-for="brand in trackBrands"
          :key="brand.key"
          class="carousel-brand-item"
        >
          <div class="carousel-brand-logo">
            <img v-if="brand.logoUrl" :src="brand.logoUrl" :alt="brand.name" />
            <span v-else v-html="brand.logoSvg"></span>
          </div>
          <div class="carousel-brand-name">{{ brand.name }}</div>
          <div class="carousel-brand-status" :class="brand.status === 'live' ? 'live' : 'soon'">
            {{ brand.status === 'live' ? t('brands.live') : t('brands.comingSoon') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const RIVIAN_SVG = '<svg viewBox="0 0 40 40" height="30" fill="none"><path d="M20 2L38 20L20 38L2 20Z" stroke="white" stroke-width="2" stroke-linejoin="round"/><path d="M13 13h9c2.8 0 5 2.2 5 5s-2.2 5-5 5h-9V13z" stroke="white" stroke-width="1.8" fill="none"/><path d="M22 23l5 5" stroke="white" stroke-width="1.8" stroke-linecap="round"/></svg>';
const MERCEDES_SVG = '<svg viewBox="0 0 40 40" height="30" fill="none"><circle cx="20" cy="20" r="17" stroke="white" stroke-width="2"/><path d="M20 20L20 5M20 20L33 27.5M20 20L7 27.5" stroke="white" stroke-width="1.8" stroke-linecap="round"/><circle cx="20" cy="20" r="2.2" fill="white"/></svg>';

type Brand = { name: string; logoUrl?: string; logoSvg?: string; status: 'live' | 'soon' };

const brands: Brand[] = [
  { name: 'Tesla',         logoUrl: 'https://cdn.simpleicons.org/tesla/ffffff',    status: 'live' },
  { name: 'Volvo',         logoUrl: 'https://cdn.simpleicons.org/volvo/ffffff',    status: 'soon' },
  { name: 'Rivian',        logoSvg: RIVIAN_SVG,                                    status: 'soon' },
  { name: 'BMW',           logoUrl: 'https://cdn.simpleicons.org/bmw/ffffff',      status: 'soon' },
  { name: 'Mercedes-Benz', logoSvg: MERCEDES_SVG,                                  status: 'soon' },
  { name: 'Porsche',       logoUrl: 'https://cdn.simpleicons.org/porsche/ffffff',  status: 'soon' },
  { name: 'Audi',          logoUrl: 'https://cdn.simpleicons.org/audi/ffffff',     status: 'soon' },
  { name: 'Polestar',      logoUrl: 'https://cdn.simpleicons.org/polestar/ffffff', status: 'soon' },
];

const trackBrands = computed(() => [
  ...brands.map((b, i) => ({ ...b, key: `a-${i}` })),
  ...brands.map((b, i) => ({ ...b, key: `b-${i}` })),
]);
</script>
